import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import counter from './counter';
import wallReducer from './wallReducer';
import web3Reducer from './web3Reducer';

const reducer = combineReducers({
    routing: routerReducer,
    counter,
    wall: wallReducer,
    web3: web3Reducer
  })
  
export default reducer


// WEBPACK FOOTER //
// ./src/reducers/index.js